<template>
  <b-card
      title="مدیریت نظرهای مقاله"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                      autocomplete="off"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>مقاله</label>
                  <z-blog
                      v-model="filterOptions.BlogId"
                      :multiple="false"
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>وضعیت</label>
                  <v-select
                      v-model="filterOptions.Status"
                      :options="enums('Status')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :sort-by="filterOptions.SortBy"
            :sort-desc="filterOptions.IsDesc"
            :busy="loading"
            :no-local-sorting="true"
            @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
                @click="showModal(data.item, false)"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                  vertical-align="center"
                  style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                      :src="data.value.Image"
                  />
                </template>
                <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>

          <template #cell(Blog)="data">
            <b-link :to="{ name: 'updateblog', params: { id: data.value.Id }}">
            <b-media
                vertical-align="center"
                style="align-items: center;"
            >
              <template #aside>
                <b-avatar
                    size="32"
                    text=" "
                    :src="data.value.Image"
                    variant="light-info"
                />
              </template>
              <span class="font-weight-bold d-block" style="color: #6e6b7b;">
                {{ data.value.Title }}
              </span>
              <!--              <small class="text-muted">{{ data.value.Mobile }}</small>-->
            </b-media>
            </b-link>
          </template>

<!--          <template #cell(Blog)="data">-->
<!--            <b-link-->
<!--                :to="{ name: 'updateblog', params: { id: data.value.Id }}"-->
<!--            >-->
<!--              {{ data.value.Title }}-->
<!--            </b-link>-->
<!--          </template>-->

          <template #cell(Status)="data">
            <b-badge
                :variant="enums('Status', 'value', data.value, 'badge')"
            >
              {{ enums('Status', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(IsAdmin)="data">
            <b-badge
                :variant="'light-' + (data.item.BlogCommentId === null ? 'primary' : data.item.IsAdmin === true ? 'warning' : 'success')"
            >
              {{ data.item.BlogCommentId === null ? 'نظر' : data.item.IsAdmin === true ? 'پاسخ ادمین' : 'پاسخ کاربر' }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            <span class="text-nowrap">
              {{ data.value | date }}
            </span>
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <feather-icon
                  v-if="data.item.BlogCommentId === null"
                  icon="PlusSquareIcon"
                  size="16"
                  @click="showModal(data.item, true)"
              />
              <span v-else style="width: 16px; height: 16px; display: inline-block;"></span>

                <feather-icon
                    icon="EditIcon"
                    size="16"
                    class="ml-1"
                    @click="showModal(data.item, false)"
                />

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :per-page.sync="filterOptions.PerPage"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        :title="isReply ? 'پاسخ' : 'نظر'"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >

        <b-col md="12">
            <b-form-group
                    label="نام"
                    label-for="Name"
            >
                <b-form-input
                        v-model="row.Name"
                        autocomplete="off"
                />
            </b-form-group>
        </b-col>

      <b-col md="12">
        <b-form-group
            label="ایمیل"
            label-for="Email"
        >
          <b-form-input
              v-model="row.Email"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="متن"
            label-for="Description"
        >
          <b-form-textarea
              id="Description"
              v-model="row.Description"
              name="Description"
              rows="5"
          />
        </b-form-group>
      </b-col>

      <b-col md="12" v-if="isReply === false">
        <b-form-group
            label="وضعیت"
            label-for="IsActive"
        >
          <v-select
              v-model="row.Status"
              :options="enums('Status')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
          />
        </b-form-group>
      </b-col>

    </b-modal>

  </b-card>
</template>

<script>

import ZBlog from '@/tools/blog.vue'

export default {
  name: 'BlogComment',
  components: {
    ZBlog,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        PerPage: 10,
        Status: null,
        UserId: null,
        BlogId: null,
        IsDesc: true,
        SortBy: 'Id',
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
          {
              key: 'Name',
              label: 'نام',
          },
        {
          key: 'Email',
          label: 'ایمیل',
        },
        {
          key: 'Blog',
          label: 'مقاله',
        },
        {
          key: 'Description',
          label: 'متن',
        },
        // {
        //   key: 'Like',
        //   label: 'لایک',
        //   sortable: true,
        // },
        // {
        //   key: 'Dislike',
        //   label: 'دیسلایک',
        //   sortable: true,
        // },
        {
          key: 'IsAdmin',
          label: 'نوع',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      isShow: false,
      row: null,
      isReply: false,
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.blogcomment.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.removeRow(this.$api.blogcomment.remove, 'Id', id)
    },
    showModal(row, isReply) {
      this.row = JSON.parse(JSON.stringify(row))
      this.isShow = true
      this.isReply = isReply
      if (isReply){
        this.row.Description = null
        this.row.Name = null
        this.row.Email = null
      }
    },
    save(){
      let url = this.$api.blogcomment.update
      if (this.isReply){
        url = this.$api.blogcomment.add
        this.row.BlogId = this.row.Blog.Id
        this.row.BlogCommentId = this.row.Id
      }

      this.$http.post(url, this.row).then(() => {
        this.update()
      })
    }
  },
}
</script>
